import { CompanyTriple, ExhibitorSponsorBanner } from '@core/data-access/models/exhibitor/exhibitor.model';
import { exhibitorFeature } from '@core/data-access/store/exhibitor/exhibitor.reducer';
import { createSelector } from '@ngrx/store';
import { isEmpty, isNil } from 'lodash';

export const selectActiveExhibitorCompanyTriple = createSelector(
  exhibitorFeature.selectExhibitorState,
  ({ activeExhibitorCompanyTriple }) => activeExhibitorCompanyTriple
);

export const selectExhibitorDetails = createSelector(
  exhibitorFeature.selectExhibitorState,
  ({ exhibitorDetails }) => exhibitorDetails
);

export const selectExhibitorDetailByCompanyTriple = (companyTriple: CompanyTriple) =>
  createSelector(selectExhibitorDetails, (exhibitorDetails) =>
    !isEmpty(exhibitorDetails) ? exhibitorDetails[companyTriple] : null
  );

export const selectExhibitorSponsorBannerByCompanyTriple = (companyTriple: CompanyTriple) =>
  createSelector(
    selectExhibitorDetailByCompanyTriple(companyTriple),
    (exhibitorDetail): ExhibitorSponsorBanner =>
      !isNil(exhibitorDetail)
        ? {
            sponsorBanner: exhibitorDetail.banner,
            sponsorBannerLink: exhibitorDetail.bannerLink
          }
        : null
  );

export const selectIsExhibitorWelcomeMessageModalOpen = createSelector(
  exhibitorFeature.selectExhibitorState,
  ({ isExhibitorWelcomeMessageModalOpen }) => isExhibitorWelcomeMessageModalOpen
);
